import { AmenityInFilter, IMonopolioPropertyTypes } from '@/interfaces'
import { EPropertyType, IProperty } from '@wiggot/search-components/types-library/src'
import ForLiving from '@/assets/svg/for-sale-to-live.svg'
import ForFlipping from '@/assets/svg/for-sale-for-flipping.svg'
import ForCaprate from '@/assets/svg/for-sale-per-caprate.svg'
import ForRent from '@/assets/svg/for-rent-last-7-days.svg'

interface IOption {
  [key: string]: string
}

export const AMENITIES_LIST: AmenityInFilter[] = [
  {
    title: 'Área de lavado',
    icon: 'wash',
    key: 'has_washing_area'
  },
  {
    title: 'Terraza',
    icon: 'deck',
    key: 'has_terrace'
  },
  {
    title: 'Gimnasio',
    icon: 'fitness_center',
    key: 'has_gym'
  },
  {
    title: 'Elevador',
    icon: 'elevator',
    key: 'has_elevator'
  },
  {
    title: 'Seguridad',
    icon: 'local_police',
    key: 'has_surveillance'
  },
  {
    title: 'Se aceptan mascotas',
    icon: 'pets',
    key: 'pets_allowed'
  }
]

export const MONOPOLIO_PROPERTY_TYPES: IMonopolioPropertyTypes[] = [
  { value: 'HOUSE', label: 'Casa' },
  { value: 'APARTMENT', label: 'Departamento' },
  // { value: 'COUNTRY_HOUSE', label: 'Quinta Campestre' },
  { value: 'TERRAIN', label: 'Terreno/Lote' },
  { value: 'OFFICE', label: 'Oficina' },
  { value: 'CONSULTING_ROOM', label: 'Consultorio' },
  { value: 'WAREHOUSE', label: 'Bodega' },
  { value: 'INDUSTRIAL_BUILDING', label: 'Nave industrial' },
  { value: 'SHOP', label: 'Local' },
  { value: 'SHOP_SHOPPING_CENTER', label: 'Local en centro comercial' },
  { value: 'RANCH', label: 'Rancho/Hacienda' },
  { value: 'BUILDING', label: 'Edificio' },
  { value: 'HOTEL', label: 'Hotel' },
  { value: 'EVENT_HALL', label: 'Salón/Terraza de eventos' },
  { value: 'COTTAGE', label: 'Cabaña' },
  { value: 'OTHER', label: 'Otro' }
]

export const OPERATION_TYPES_DICT: IOption = {
  'for-sale': 'SALE',
  'for-lease': 'LEASE'
}

export const OPPORTUNITIES: IOption[] = [
  {
    title: 'Comprar y vivir',
    description: 'Propiedades con precio debajo de estimación de mercado.',
    id: 'for-sale-to-live',
    badge: ForLiving,
    colorClasses: 'border-notif-green hover:bg-notif-green',
    color: 'bg-notif-green',
    type: 'SALE'
  },
  {
    title: 'Comprar y remodelar',
    description:
      'Propiedades con márgenes que permiten obtener un potencial de ganancia.',
    id: 'for-sale-for-flipping',
    badge: ForFlipping,
    colorClasses: 'border-notif-green hover:bg-notif-green',
    color: 'bg-notif-green',
    type: 'SALE'
  },
  {
    title: 'Comprar y rentar a largo plazo',
    description: 'Propiedes con oportunidad de retorno en el largo plazo.',
    id: 'for-sale-per-caprate',
    badge: ForCaprate,
    colorClasses: 'border-notif-orange hover:bg-notif-orange',
    color: 'bg-notif-orange',
    type: 'SALE'
  },
  {
    title: 'Publicadas en los últimos 7 días',
    description: 'Lo más fresco del mercado para tí.',
    id: 'for-rent-last-7-days',
    badge: ForRent,
    colorClasses: 'border-notif-yellow hover:bg-notif-yellow',
    color: 'bg-notif-yellow',
    type: 'LEASE'
  },
  {
    title: 'Están a punto de rentarse',
    description: 'Estas propiedades no durarán mucho tiempo más en el mercado.',
    id: 'for-rent-soon-to-be',
    badge: ForCaprate,
    colorClasses: 'border-notif-orange hover:bg-notif-orange',
    color: 'bg-notif-orange',
    type: 'LEASE'
  },
  {
    title: 'A un gran precio de renta',
    description: 'Las identificamos con un precio de renta bajo en el mercado.',
    id: 'for-rent-price-opportunity',
    badge: ForFlipping,
    colorClasses: 'border-notif-green hover:bg-notif-green',
    color: 'bg-notif-green',
    type: 'LEASE'
  }
]

export const OPERATION_OPTIONS = [
  { value: 'SALE', label: 'Venta', icon: 'local_offer' },
  { value: 'PRESALE', label: 'Preventa', icon: 'key' },
  { value: 'LEASE', label: 'Renta', icon: 'confirmation_number' }
]

// dummyProperty se muestra un instante mientras arranca la animacion de
// busqueda (ver Results.tsx), asi que se tipa explicitamente contra
// IProperty para que TS obligue a mantenerlo completo si esa interfaz
// cambia. Los campos agregados abajo (que no traia el mock original) usan
// los mismos valores neutros por defecto que convertResponseToOldFormat en
// apis-library/src/services/propertyServices.ts.
export const dummyProperty: IProperty = {
  id: 'property-dummy',
  createdAt: '2024-10-11T17:31:03.274Z',
  listingType: EPropertyType.SALE,
  type: EPropertyType.SALE,
  propertyType: 'apartment',
  latitude: 19.3614025,
  longitude: -99.1632719,
  surfaceTotal: 120,
  terrainSurface: 0,
  numBedrooms: 3,
  numBathrooms: 3,
  numParkingLots: 2,
  numFloors: 1,
  builtYear: 2015,
  addressStreet: 'Mexico Coyoacan',
  addressNumber: 'Mexico Coyoacan',
  addressNeighborhood: 'Xoco',
  addressMunicipality: 'Benito Juárez',
  addressState: 'Ciudad de México',
  proxyPublishedAt: '2024-10-11T17:24:51.000Z',
  coverImage:
    'property_photos/93971b7f5ca545569233cc6c85fb772a/93971b7f5ca545569233cc6c85fb772a_1.jpg',
  capitalizationRate: null,
  discountFromPrediction: 0,
  discountFromPredictionPercent: 0,
  price: 6300000,
  predictionPriceSale: 0,
  predictionPricePerSquareMeterSale: 0,
  predictionPriceRent: 0,
  predictionPricePerSquareMeterRent: 0,
  predictionPricePerSquareMeterLower: 0,
  predictionPricePerSquareMeterUpper: 0,
  isPresale: false,
  petsAllowed: false,
  selectedId: '93971b7f5ca545569233cc6c85fb772a',
  providerId: 5,
  itemId: '27341748',
  listings: [],
  listingsOwners: [],
  fullAddress: 'Mexico coyoacan, Xoco, Benito juárez, Ciudad de méxico',
  metrics: {
    capRate: 0,
    pricePerSquareMeter: 52500,
    rentPerSquareMeter: 0
  },
  shareUrl:
    '/venta/cdmx/benito-juarez/xoco/mexico-coyoacan/cdddd503-c888-4df6-95bf-53832b07edaf',
  shortAddress: 'Xoco, Benito juárez, Ciudad de méxico',
  ABGroup: '',
  adIdPictures: '27341748',
  attributes: [],
  balconySurface: 0,
  cveEnt: '',
  cveGeo: '',
  cveMun: '',
  deletedAt: '',
  externalId: '27341748',
  features: [],
  flagBannedScraper: false,
  geocertainty: 'low',
  highlights: {},
  isDevelopment: false,
  isDirectDeal: false,
  isDiscountedFromPrediction: false,
  isNewPropertyProb: 0,
  lastOffMarketDate: '',
  lastOffMarketPrice: '',
  luxuryCategoryBathrooms: '',
  onMarket: true,
  onMarketDs: true,
  owners: [],
  phone: '',
  photos: [],
  propertyCode: '',
  propertyInteriorCode: '',
  recommendationId: '',
  scraper: '',
  seller: '',
  sepomexId: '',
  status: true,
  tag: null,
  timeOnMarketDs: '',
  updatedAt: '2024-10-11T17:31:03.274Z',
  visitDate: 0
}
